module.exports = __webpack_public_path__ + "files/15d661ed61f7fe36efe59209f75ad664.png";